import { FirebaseAppProvider } from 'reactfire'
import { getFirebaseAppInstance } from '@dasa/nsw-module-firebase'
import { ThemeProvider } from '@dasa-health/alma-react'

import { navTheme } from 'themes'

import { RemoteConfigProvider } from './RemoteConfigProvider'

export function Providers({ children }) {
  return (
    <ThemeProvider theme={navTheme}>
      <FirebaseAppProvider firebaseApp={getFirebaseAppInstance('RemoteConfig')}>
        <RemoteConfigProvider>{children}</RemoteConfigProvider>
      </FirebaseAppProvider>
    </ThemeProvider>
  )
}
